import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=7a0b8542&scoped=true"
import script from "./DetailForm.vue?vue&type=script&lang=js"
export * from "./DetailForm.vue?vue&type=script&lang=js"
import style0 from "./DetailForm.vue?vue&type=style&index=0&id=7a0b8542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b8542",
  null
  
)

export default component.exports